import { FieldType } from 'src/Common/Filters/interfaces/FiltersView';

export const AzureISVFilterConfig = [
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'workItemStates',
    keyName: 'Name',
    internalName: 'fields/state',
    responseFormat: 'string',
  },
  {
    fieldId: 'SubState',
    fieldName: 'Sub State',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'subStates',
    keyName: 'subState',
    internalName: 'fields/substate',
    responseFormat: 'string',
  },
  {
    fieldId: 'Areas',
    fieldName: 'Area(s)',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'areas',
    keyName: 'area',
    internalName: 'fields/areafield',
    responseFormat: 'string',
  },
  {
    fieldId: 'SponsorshipStartDate',
    fieldName: 'Sponsorship Start Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/SponsorshipStartDate',
    responseFormat: 'date',
  },
  {
    fieldId: 'SponsorshipEndDate',
    fieldName: 'Sponsorship End Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/SponsorshipEndDate',
    responseFormat: 'date',
  },
];
